import { render, staticRenderFns } from "./index.vue?vue&type=template&id=485e7ef3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=485e7ef3&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=485e7ef3&prod&lang=css"
import style2 from "./index.vue?vue&type=style&index=2&id=485e7ef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e7ef3",
  null
  
)

export default component.exports